import {
  Box,
  Button,
  Divider,
  Flex,
  Icon,
  Input,
  SimpleGrid,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  BLUEMONEDD,
  BLUEMONEDDBUTTONS,
  GRAY_NEUTRAL,
  GREENMONEDD,
  REDMONEDD,
  VARIANT,
  WHITE,
} from "../../../constants/colors";
import DateDropdown from "../../../defaultComponents/dateDropdown";
import {
  ExtractListCards,
  simplifiedExtract,
} from "../../../interfaces/defaultInterfaces";
import ExtratoApi from "../../../services/ExtratoAPI";
import { JWTToken } from "../../vendas/listaDeVendas/SalesList";
import CardExtractDetails from "./defaultComponents/cardExtractDetails";
import TableRelease from "./defaultComponents/tableRelease";
import TableSalesCredit from "./defaultComponents/tableSalesCredit";
import TableTransfers from "./defaultComponents/tableTransfers";
import jwt_decode from "jwt-decode";
import { FaArrowLeft, FaArrowRight, FaFileExport } from "react-icons/fa";
import { dateForValueInput } from "../../../constants/dataFormat";
import TableTransfersWithStatus from "./defaultComponents/tableTransfersWithStatus";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";
import SalesListAPI from "../../../services/SalesListApi";
import { useRecoilState } from "recoil";
import { LoggedUser } from "../../../atoms/userLogged";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";
import TableReleaseContract from "./defaultComponents/tableReleaseContract";

export default function ExtractDetails() {
  const navigate = useNavigate();
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  // const id = Number(jwtToken.idCliente);

  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const id =
    user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);

  const dataInicio = moment(Date())
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");
  const dataFim = moment(Date()).endOf("day").format("YYYY-MM-DDTHH:mm:ss");

  const [extractList, setExtractList] = useState(Array<simplifiedExtract>);
  const [cardExtract, setCardExtract] = useState<ExtractListCards>();
  const [saldoAtual, setSaldoAtual] = useState(0);
  const initialValues = {
    initialDateFilter: dataInicio,
    finalDateFilter: dataFim,
  };
  const [saldo, setSaldo] = useState({
    saldoAnterior: 0,
    saldoPeriodo: 0,
  });
  const [filtros, setFiltros] = useState(initialValues);
  const [loading, setLoading] = useState(false);

  async function getExtractDetails() {
    try {
      setLoading(true);
      const response = await ExtratoApi.getExtractPerClient(
        1,
        100,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      setExtractList(response.data);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  }

  async function getExtratcList() {
    try {
      const response = await ExtratoApi.getExtractList(
        1,
        100,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id,
        ""
      );
      setCardExtract(response[0]);
      console.log("response", response[0]);
      const somaSaldoPositivo =
        response[0].vendaCartaoDebito +
        response[0].vendaCartao +
        response[0].sucessoDisputa +
        response[0].vendaBoleto +
        response[0].vendaPix +
        response[0].lancamentoManualCredito;
      const somaSaldoNegativo =
        response[0].cancelamentoVendaCartao +
        response[0].disputaVendaCartao +
        response[0].cancelamentoBoleto +
        response[0].cancelamentoPIX +
        response[0].pagamentoBoleto +
        response[0].transferenciaTED +
        response[0].lancamentoManualDebito;
      setSaldoAtual(somaSaldoPositivo - somaSaldoNegativo);
    } catch (error) {
      console.log("error", error);
      toast.error("ERRO");
    }
  }

  async function getSaldo() {
    try {
      const response = await ExtratoApi.getSaldo(
        1,
        100,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      console.log("getSaldo", response);
      setSaldo({
        ...saldo,
        saldoAnterior: response.data[0].saldoAnterior,
        saldoPeriodo: response.data[0].saldoPeriodo,
      });
    } catch (error) {
      console.log("error", error);
    }
  }

  useEffect(() => {
    getExtractDetails();
    getExtratcList();
    getSaldo();
  }, [filtros.initialDateFilter, filtros.finalDateFilter, id]);

  const [disable, setDisable] = useState(false);

  async function Export() {
    try {
      setDisable(true);
      const response = await SalesListAPI.exportDetailedExtract(
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      fileDownload(response, "extrato.xlsx");
      setDisable(false);
    } catch (error) {
      toast.error("Não foi possível exportar o arquivo!");
    }
  }

  return (
    <Flex
      w={"100%"}
      h={"100%"}
      bgColor={WHITE}
      shadow={"xl"}
      flexDirection={"column"}
      overflowY={"scroll"}
    >
      <Flex
        w={"100%"}
        h={"8%"}
        py={7}
        px={10}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Text fontWeight={"bold"}>
          Consulta de Transações:{" "}
          {cardExtract
            ? cardExtract.isCnpj === true
              ? cardExtract.razaoSocial
              : `${cardExtract.nome} ${cardExtract.sobrenome}`
            : ""}
        </Text>
        <Button
          bgColor={BLUEMONEDDBUTTONS}
          color={WHITE}
          isDisabled={disable}
          onClick={() => {
            Export();
          }}
        >
          {disable === true ? (
            <Spinner />
          ) : (
            <>
              <Icon mr={2} as={FaFileExport} />
              Exportar
            </>
          )}
        </Button>
      </Flex>
      <Flex
        w={"97%"}
        h={"8%"}
        py={4}
        px={10}
        marginX={"auto"}
        mb={4}
        border={"2px solid #e3e3e3"}
        shadow={"md"}
        borderRadius={"8px"}
        justifyContent={"space-evenly"}
        alignItems={"center"}
      >
        <Button
          bgColor={BLUEMONEDD}
          color={WHITE}
          isDisabled={loading}
          onClick={() => {
            setFiltros({
              ...filtros,
              initialDateFilter: moment(filtros.initialDateFilter)
                .add(-1, "day")
                .startOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.SSS"),
              finalDateFilter: moment(filtros.finalDateFilter)
                .add(-1, "day")
                .endOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.SSS"),
            });
          }}
        >
          {loading ? (
            <Spinner />
          ) : (
            <>
              <Icon mr={2} as={FaArrowLeft} />
              Anterior
            </>
          )}
        </Button>
        <Input
          value={moment(filtros.initialDateFilter).format(dateForValueInput)}
          type={"date"}
          w={"22%"}
          isDisabled={loading}
          onChange={(e: any) => {
            setFiltros({
              ...filtros,
              initialDateFilter: moment(e.target.value)
                .startOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.SSS"),
              finalDateFilter: moment(e.target.value)
                .endOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.SSS"),
            });
          }}
        ></Input>
        {/* <DateDropdown filtros={filtros} setFiltros={setFiltros} /> */}
        <Button
          bgColor={BLUEMONEDD}
          color={WHITE}
          isDisabled={loading}
          onClick={() => {
            setFiltros({
              ...filtros,
              initialDateFilter: moment(filtros.initialDateFilter)
                .add(1, "day")
                .startOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.SSS"),
              finalDateFilter: moment(filtros.finalDateFilter)
                .add(1, "day")
                .endOf("day")
                .format("YYYY-MM-DDTHH:mm:ss.SSS"),
            });
          }}
        >
          {loading ? (
            <Spinner />
          ) : (
            <>
              Posterior
              <Icon ml={2} as={FaArrowRight} />
            </>
          )}
        </Button>
      </Flex>
      <Flex
        w={"97%"}
        h={"27%"}
        border={"2px solid #e3e3e3"}
        shadow={"md"}
        marginX={"auto"}
        alignItems={"center"}
        mb={1}
        borderRadius={"8px"}
      >
        <SimpleGrid columns={4} spacingX={4} spacingY={2} w={"100%"} px={5}>
          <CardExtractDetails
            valor={saldo.saldoAnterior}
            description={`Saldo em ${moment(filtros.initialDateFilter)
              .add(-1, "day")
              .format("DD/MM/YYYY")}`}
            color={BLUEMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.vendaCartao : 0}
            description={"Vendas Crédito"}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract?.vendaCartaoDebito : 0}
            description={"Vendas Débito"}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.vendaBoleto : 0}
            description={"Vendas Boletos"}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.vendaPix : 0}
            description={"Vendas PIX"}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.lancamentoManualCredito : 0}
            description={"Lançamentos de Crédito"}
            color={GREENMONEDD}
          />

          <CardExtractDetails
            valor={cardExtract ? cardExtract.cancelamentoBoleto : 0}
            description={`Cancelamento Boleto`}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.cancelamentoPIX : 0}
            description={`Cancelamento Pix`}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.vendaBolepix : 0}
            description={"Vendas BolePix"}
            color={GREENMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.cancelamentoRemessaBoleto : 0}
            description={`Cancelamento Remessa Boleto`}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={
              cardExtract ? cardExtract.cancelamentoRemessaTransferencia : 0
            }
            description={`Cancelamento Remessa Transferencia`}
            color={REDMONEDD}
          />

          <CardExtractDetails
            valor={cardExtract ? cardExtract.lancamentoManualDebito : 0}
            description={"Lançamentos de Débito"}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.pagamentoBoleto : 0}
            description={"Pagamentos de Boleto"}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.cancelamentoBolepix : 0}
            description={"Cancelamento BolePix"}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.transferenciaTED : 0}
            description={"Transferências"}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.cancelamentoVendaCartao : 0}
            description={"Vendas Canceladas"}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={cardExtract ? cardExtract.disputaVendaCartao : 0}
            description={"Venda Disputada"}
            color={REDMONEDD}
          />
          <CardExtractDetails
            valor={saldo.saldoAnterior + saldo.saldoPeriodo}
            description={`Saldo em ${moment(filtros.finalDateFilter).format(
              "DD/MM/YYYY"
            )}`}
            color={BLUEMONEDD}
          />

          {/* <CardExtractDetails
            valor={cardExtract?.sucessoDisputa}
            description={`Sucesso Disputa`}
            color={BLUEMONEDD}
          /> */}
        </SimpleGrid>
      </Flex>
      {loading === false ? (
        <Flex
          w={"100%"}
          h={"60vh"}
          alignItems={"flex-start"}
          px={5}
          flexDirection={"column"}
        >
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Lançamento Manual Crédito"
              item.tipoLancamento.id == 23
          ).length ? (
            <TableRelease
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento ==
                    // "Lançamento Manual Crédito"
                    item.tipoLancamento.id == 23
                )
              }
              title={"Transferência Via Rede Crédito"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Lançamento Manual Crédito"
              item.tipoLancamento.id == 24
          ).length ? (
            <TableRelease
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento ==
                    // "Lançamento Manual Crédito"
                    item.tipoLancamento.id == 24
                )
              }
              title={"Transferência Via Rede Débito"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Lançamento Manual Crédito"
              item.tipoLancamento.id == 16
          ).length ? (
            <TableRelease
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento ==
                    // "Lançamento Manual Crédito"
                    item.tipoLancamento.id == 16
                )
              }
              title={"Lançamento Manual Crédito"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Lançamento Manual Débito"
              item.tipoLancamento.id == 17
          ).length ? (
            <TableRelease
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Lançamento Manual Débito"
                    item.tipoLancamento.id == 17
                )
              }
              title={"Lançamento Manual Débito"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter((item: any) => item.tipoLancamento.id == 25)
            .length ? (
            <TableReleaseContract
              data={
                extractList &&
                extractList.filter((item: any) => item.tipoLancamento.id == 25)
              }
              title={"Débito de Contrato"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Transferencia TED"
              item.tipoLancamento.id == 15
          ).length ? (
            <TableTransfers
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Transferencia TED"
                    item.tipoLancamento.id == 15
                )
              }
              title={"Transferencia TED"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Transferencia TED"
              item.tipoLancamento.id == 20
          ).length ? (
            <TableTransfersWithStatus
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Transferencia TED"
                    item.tipoLancamento.id == 20
                )
              }
              title={"Cancelamento/Falha de Remessa Transferencia"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Pagamento Boleto"
              item.tipoLancamento.id == 14
          ).length ? (
            <TableTransfers
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Pagamento Boleto"
                    item.tipoLancamento.id == 14
                )
              }
              title={"Pagamento Boleto"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Pagamento Boleto"
              item.tipoLancamento.id == 26
          ).length ? (
            <TableTransfers
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Pagamento Boleto"
                    item.tipoLancamento.id == 26
                )
              }
              title={"BOLEPIX"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Pagamento Boleto"
              item.tipoLancamento.id == 19
          ).length ? (
            <TableTransfersWithStatus
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Pagamento Boleto"
                    item.tipoLancamento.id == 19
                )
              }
              title={"Cancelamento/Falha de Remessa Boleto"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
              item.tipoLancamento.id == 1
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
                    item.tipoLancamento.id == 1
                )
              }
              title={"Vendas no cartão de Crédito"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
              item.tipoLancamento.id == 2
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
                    item.tipoLancamento.id == 2
                )
              }
              title={"Cancelamentos de Vendas no Cartão"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Venda Cartão Débito"
              item.tipoLancamento.id == 18
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Venda Cartão Débito"
                    item.tipoLancamento.id == 18
                )
              }
              title={"Vendas no cartão de Débito"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Venda PIX"
              item.tipoLancamento.id == 10
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Venda PIX"
                    item.tipoLancamento.id == 10
                )
              }
              title={"Vendas no PIX"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Venda Boleto"
              item.tipoLancamento.id == 9
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Venda Boleto"
                    item.tipoLancamento.id == 9
                )
              }
              title={"Vendas no Boleto"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Venda Disputa"
              item.tipoLancamento.id == 3
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Venda Disputa"
                    item.tipoLancamento.id == 3
                )
              }
              title={"Vendas Disputa"}
            />
          ) : (
            <></>
          )}
          {extractList?.filter(
            (item: any) =>
              // item.tipoLancamento.lancamento == "Chargeback"
              item.tipoLancamento.id == 5
          ).length ? (
            <TableSalesCredit
              data={
                extractList &&
                extractList.filter(
                  (item: any) =>
                    // item.tipoLancamento.lancamento == "Chargeback"
                    item.tipoLancamento.id == 5
                )
              }
              title={"Chargeback"}
            />
          ) : (
            <></>
          )}
          <Flex
            w={"97%"}
            minH={"120px"}
            py={4}
            px={10}
            marginX={"auto"}
            mb={4}
            alignItems={"center"}
          ></Flex>
        </Flex>
      ) : (
        <Flex
          w={"100%"}
          h={"60vh"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Spinner color={VARIANT} size="lg" />
        </Flex>
      )}
    </Flex>
  );
}
